import React from 'react';
import { useI18n } from "src/utils/lni18n";
import { PublishInBatchResponse } from "src/coursepart/domain/PublishInBatchResponse";

export const PublishedPartsList: React.FC<{ parts: PublishInBatchResponse[] }> = ({
    parts
}) => {
    const { languageService: t } = useI18n();
    
    if (!parts || parts.length === 0) {
        return null;
    }
    
    return (

        <table className="table table-condensed table-striped">
            <thead>
                <tr>
                    <th>
                        {t.getText("name")}
                    </th>
                    <th>
                        {t.getText("comment")}
                    </th>
                </tr>
            </thead>
            <tbody>

                {parts.map(d => (
                    <tr key={d.PartId} className={`${!d.Result ? 'table-danger': ''}`}>
                        <td>
                            {d.Name}
                        </td>
                        <td className="preserve-white">
                           {d.Message }
                        </td>

                    </tr>)
                )}

            </tbody>
        </table>

    )
}